import React, { Component } from 'react';
import {
    Link
} from "react-router-dom";
import {ApiBaseUrl} from '../../constants';
import { AuthContext } from "./../../context/auth";
import { trackPromise } from 'react-promise-tracker';
import { withSnackbar } from 'react-simple-snackbar';

class Favorites extends Component{
    static contextType = AuthContext;
    state = {
        data:[]
    }

    deleteHandler = (id) => {
        trackPromise(
        fetch(ApiBaseUrl + "/consumer/favourite/"+id,
            {
                method: 'GET',
                headers:
                    {
                        "Authorization": "Bearer "+this.context.token
                    }
            })
            .then(res => res.json())
            .then(
                (result) => {
                    this.props.openSnackbar(result.message)
                    if(result.success)
                        this.getFavorites('delete');
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
        );
    }

    getFavorites = (from = 'delete') => {
        trackPromise(
        fetch(ApiBaseUrl + "/consumer/favourites",
            {
                method: 'GET',
                headers:
                    {
                        "Authorization": "Bearer "+this.context.token
                    }
            })
            .then(res => res.json())
            .then(
                (result) => {
                    if(!result.success)
                        this.props.openSnackbar(result.message)
                    else {
                        if(from === 'delete') {
                            this.setState({
                                data: result.data
                            });
                        }
                        else
                            this.setState({
                                data: result.data
                            });
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
        )
    }

    componentDidMount(){
        window.scrollTo(0, 0)
        document.getElementById('body').className='favorites'
        this.getFavorites('load');
    }
    componentWillUnmount () {
        document.getElementById('body').className=''
    }

    render(){
        return(
            <React.Fragment>
                <div className="overlay">
                    <img src={`${process.env.PUBLIC_URL}/image/test-6.png`} alt=""/>
                </div>
                <div className="choose-deals-outer p-l-0 p-r-0">
                    <div className="container">
                        <div className="row">
                        {this.state.data.length ?
                            <div className="associatehost-outer pt-0 pb-0">
                            {this.state.data.map(favorite => (
                                <div className="each--associatehost-row overlay-bg">
                                    <div className="row">
                                        <Link to={favorite.deal_type === 'allday' ? `${process.env.PUBLIC_URL}/allday/deal/`+favorite._id : `${process.env.PUBLIC_URL}/oneday/deal/`+favorite._id} key={favorite._id} className="link-box"></Link>
                                        <div className="col-sm-9 col-9">
                                            <div className="eacch--associatehost-outer d-mob-flex d-md-flex d-lg-flex p-t-15">
                                                <div className="each--associatehost-pic">
                                                    <img src={favorite.image} alt={favorite.name}/>
                                                </div>
                                                <div className="each--associatehost-info">
                                                    <h6 className="each--associatehost-info-heading custom-height">{favorite.category.name}</h6>
                                                    <p className="each--associatehost-info-para custom-height">{favorite.name}</p>
                                                    <div className="view-host-deals">
                                                        <Link to={favorite.deal_type === 'allday' ? `${process.env.PUBLIC_URL}/allday/deal/`+favorite._id : `${process.env.PUBLIC_URL}/oneday/deal/`+favorite._id}
                                                              className="grad-on cart-view-btn fav-custom-btn">View
                                                            Details</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-3 col-3">
                                            <div onClick={deleteClick => this.deleteHandler(favorite._id)} className="favorite_icon_page">
                                                <div className="single-deal-image-card-heart-outer pre-liked">
                                                    <i className="fa fa-heart-o fill-toggle fa-heart"></i>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>

                            ))}
                            </div> :
                            <div className="col-12 text-center text-white">
                                You don't have any favourite deal yet
                            </div>
                        }
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default withSnackbar(Favorites,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});